import styled from "styled-components"
import theme from "styles/theme-main"
import { media } from "../../utils/utils"
import { withStyles } from "@material-ui/core"
import Input from "@material-ui/core/Input"
import InputLabel from "@material-ui/core/InputLabel"
import FormControl from "@material-ui/core/FormControl"
import Text from "components/Text"

export const FormIcon = styled.div`
  width: 20px;
  height: 20px;
  margin-left: 9px;
  color: ${props =>
    props.variant === "success" ? theme.colors.success : theme.colors.danger};
`

export const Hint = styled.p`
  padding-top: 14px;
  color: ${theme.colors.textPrimary};
  font-size: 13px;
  line-height: 20px;
  font-weight: 400;
`

export const OptionalWrapper = styled.span`
  font-size: 14px;
`

export const Heading = styled(Text)`
  display: ${props => (props.inlineLabels ? "inline-block" : "block")}
  margin-bottom: 14px;
`

export const SubHeading = styled(Text)`
   display: ${props => (props.inlineLabels ? "inline-block" : "block")}
   margin-left: ${props => (props.inlineLabels ? "10px" : 0)}
  margin-bottom: 14px;
`

export const TooltipContainer = styled.div`
  position: absolute;
  left: calc(100% - 30px);
  top: 23px;
  z-index: 999;
`

export const Message = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: ${props =>
    props.errorDisplay === "below" ? "inherit" : "absolute"};
  top: 20px;
  right: 0;

  ${media.md`
   // position: static;
   // display: flex;
  `};
`

export const IconWrapper = styled.div`
  width: 17.7px;
  height: 17.7px;
  color: #adb1b5;
  display: inline-block;
  position: absolute;
  bottom: 10px;
`

export const OKLength = styled.div`
  color: green;
  margin-top: 70px;
`

export const BadLength = styled.div`
  color: red;
  margin-top: 70px;
`

export const StyledFormControl = withStyles({
  root: {
    display: "inline-block",
    maxWidth: "448px",
    width: "100%",
    // eslint-disable-next-line no-useless-computed-key
    ["@media (max-width:1000px)"]: {
      maxWidth: "100%",
    },
  },
})(FormControl)

export const StyledFormControlMedium = withStyles({
  root: {
    display: "inline-block",
    maxWidth: "216px",
    width: "100%",
    // eslint-disable-next-line no-useless-computed-key
    ["@media (max-width:1000px)"]: {
      maxWidth: "100%",
    },
  },
})(FormControl)

export const StyledFormControlLarge = withStyles({
  root: {
    display: "inline-block",
    maxWidth: "332px",
    width: "100%",
    // eslint-disable-next-line no-useless-computed-key
    ["@media (max-width:1000px)"]: {
      maxWidth: "100%",
    },
  },
})(FormControl)

export const StyledFormControlXLarge = withStyles({
  root: {
    display: "inline-block",
    maxWidth: "682px",
    width: "100%",
    // eslint-disable-next-line no-useless-computed-key
    ["@media (max-width:1000px)"]: {
      maxWidth: "100%",
    },
  },
})(FormControl)

export const StyledFormControlXXLarge = withStyles({
  root: {
    display: "inline-block",
    maxWidth: "750px",
    width: "750px",
  },
})(FormControl)

export const StyledInputLabel = withStyles(theme => ({
  root: {
    whiteSpace: "nowrap",
    fontFamily: `${theme.typography.fontFamily}`,
    color: `${theme.palette.text.secondary} !important`,
    paddingLeft: "10px",
    fontSize: "16px",
    // eslint-disable-next-line no-useless-computed-key
    ["@media (max-width:1000px)"]: {
      paddingLeft: "9px",
    },
  },
  shrink: {
    color: `${theme.palette.text.secondary} !important`,
  },
}))(InputLabel)

export const StyledInput = withStyles(theme => ({
  input: {
    backgroundColor: "transparent !important",
    fontFamily: `${theme.typography.fontFamily} !important`,
    // lineHeight: `24px !important`,
    fontWeight: 700,
    color: `${theme.palette.text.primary} !important`,
    paddingLeft: "16px",
    // eslint-disable-next-line no-useless-computed-key
    ["@media (max-width:1000px)"]: {
      paddingLeft: "9px",
    },
  },
  underline: {
    "&:after": {
      borderBottom: `2px solid ${theme.palette.primary.main}`,
    },
    "&error:after": {
      borderBottomColor: theme.palette.error.main,
      transform: "scaleX(1)", // error is always underlined in red
    },
    "&:before": {
      borderBottom: `1px solid ${theme.palette.text.disabled}`,
      //content: '"\\00a0"'
    },
    "&:hover:not(disabled):not(focused):not(error):before": {
      borderBottom: `2px solid #c4cace !important`,
    },
    "&disabled:before": {
      borderBottom: `1px dotted ${theme.palette.primary.main}`,
    },
  },
}))(Input)
